export default __webpack_public_path__ + "static/media/trash-icon.50890b4c.svg";